import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id", "name", "onChange", "checked", "required", "disabled"]
const _hoisted_3 = ["for"]


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioGroup',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    options: {
        type: Array,
    },
    name: {
        type: String,
    },
    id: {
        type: String,
    },
    customLabelClass: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false,
    }, 
    readonly: {
        type: Boolean,
        default: false,
    },
    disabled : {
        type: Boolean,
        default: false,
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
    return (_openBlock(), _createElementBlock("div", {
      id: __props.id,
      key: index,
      class: _normalizeClass(["flex items-center radio-group", __props.readonly ? 'pointer-events-none cursor-default' : ''])
    }, [
      _createElementVNode("input", {
        id: __props.name + option.id,
        name: __props.name,
        type: "radio",
        class: "w-6 h-6 border-gray-300 cursor-pointer text-primary-600 focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-primary-600",
        onChange: ($event: any) => (_ctx.$emit('update:modelValue', option.value)),
        checked: __props.modelValue === option.value,
        required: __props.required,
        disabled: __props.disabled
      }, null, 40, _hoisted_2),
      _createElementVNode("label", {
        for: __props.name + option.id,
        class: _normalizeClass(["block ml-2 text-sm font-medium cursor-pointer", [__props.modelValue === option.value ? 'text-neutral-900' : 'text-neutral-900', __props.customLabelClass]])
      }, _toDisplayString(option.label), 11, _hoisted_3)
    ], 10, _hoisted_1))
  }), 128))
}
}

})